import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GLAcctDataModel } from '../interfaces/general-ledger';

@Injectable({
    providedIn: 'root',
})
export class GeneralLedgerService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/GLAcct/').replace('{version}', this.version);

    constructor(private http: HttpClient) {}

    getGLAccts(): Observable<GLAcctDataModel[]> {
        return this.http.get<GLAcctDataModel[]>(this._url + 'Get/');
    }

    insertGLAcct(glAcct: GLAcctDataModel): Observable<any> {
        return this.http.post<any>(this._url + 'InsertGlAcct/', glAcct, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    submitChanges(changedOrAddedProducts) {
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'SubmitChanges', changedOrAddedProducts).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }
}
